import type { StorageAddonId } from './storagePlans';

export const STORAGE_PURCHASE_CONSENT_VERSION = 'storage-2026-10-25';
export interface StoragePurchaseQuote {
  id: string;
  offerId: StorageAddonId;
  amountToday: number;
  recurringAmount: number;
  periodEnd: number;
  expiresAt: number;
  serverNow: number;
}
export interface StoragePurchaseState {
  quote: StoragePurchaseQuote;
  status: 'quoted' | 'processing' | 'pending' | 'complete' | 'refunded' | 'expired' | 'superseded';
  paymentUrl?: string;
}
export function safeStoragePaymentUrl(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  try {
    const url = new URL(value);
    if (url.protocol === 'https:' && url.hostname === 'invoice.stripe.com' && !url.username && !url.password) return url.href;
  } catch { /* No link for invalid provider URLs. */ }
}
